export default __webpack_public_path__ + "static/Geek-fc9aead8616f9170458d3834917910a4.png";